import React from 'react';
import PropTypes from 'prop-types';
import SMConst from 'lib/SMConst';
import SMUserResource from 'resources/SMUserResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';

class SMUReservationMessageCloseView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ""
    };
  }
  
  formDidSubmit(e){
    e.preventDefault();
    let formData = new FormData(e.currentTarget);
    $(this.refs.form).startLoading();
    SMUserResource.closeMessage(this.props.reservation, formData, (data, error, xhr)=>{
      $(this.refs.form).stopLoading();
      
      if (!error) {
        if(this.props.delegate && typeof this.props.delegate.messageDidClose === 'function'){
          this.props.delegate.messageDidClose(data, xhr);
        }
      } else {
        if(this.props.delegate && typeof this.props.delegate.messageDidCloseFail === 'function'){
          this.props.delegate.messageDidCloseFail(error, xhr);
        }
        this.setState({errorMessage:xhr.responseJSON.message});
      }
    });
  }
  
  render() {
    let reservation = this.props.reservation;
    let messageCloseTitle = reservation.need_preview && reservation.message_disable_reason_type == SMConst.MessageDisableReasonType.Expired ?
                              I18n.t("dashboard.text_000613") : I18n.t("dashboard.text_000610");
    let errorRow = (this.state.errorMessage) ? <p style={{textAlign:"left"}} className="is-error mb15 mt10">{this.state.errorMessage}</p> : "";
    
    return (
      <div ref="form" className="form-casette maincol-lightbox__form">
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <h2 className="dashboard-title mb30 ta-c" dangerouslySetInnerHTML={{__html: messageCloseTitle}} />
          <p className="dashboard-title__supplement mb20 ta-c">{I18n.t("dashboard.text_000618")}</p>
          <div className="form-box">
            <input type="radio" value={SMConst.MessageClosedReasonType.Condition} id="form-radio01__02" name="message_closed_reason_type" defaultChecked />
            <label htmlFor="form-radio01__02" className="form-radio__s">{I18n.t("dashboard.label_000721")}</label><br />
            <input type="radio" value={SMConst.MessageClosedReasonType.Schedule} id="form-radio01__03" name="message_closed_reason_type" />
            <label htmlFor="form-radio01__03" className="form-radio__s">{I18n.t("dashboard.label_000722")}</label><br />
            <input type="radio" value={SMConst.MessageClosedReasonType.Price} id="form-radio01__04" name="message_closed_reason_type" />
            <label htmlFor="form-radio01__04" className="form-radio__s">{I18n.t("dashboard.label_000723")}</label><br />
            <input type="radio" value={SMConst.MessageClosedReasonType.Disintermediation} id="form-radio01__01" name="message_closed_reason_type" />
            <label htmlFor="form-radio01__01" className="form-radio__s">{I18n.t("dashboard.label_000720")}</label><br />
            <input type="radio" value={SMConst.MessageClosedReasonType.Other} id="form-radio01__05" name="message_closed_reason_type" />
            <label htmlFor="form-radio01__05" className="form-radio__s">{I18n.t("dashboard.label_000724")}</label>

            <p className="dashboard-title__supplement mb5 mt20">{I18n.t("dashboard.text_000611")}</p> 
            <textarea name="message_closed_reason_description" className="w500 h80" placeholder={I18n.t("dashboard.text_000612")}></textarea>
            {errorRow}
          </div>
          <div className="ta-c mb30">
            <SMFormSubmitButton 
              title={I18n.t("dashboard.label_000108")} 
              options={{className: "button-green maincol-buttonarea__button"}} />
          </div>
        </form>
      </div>
    );
  }
}
SMUReservationMessageCloseView.propTypes = {
  delegate: PropTypes.object,
  reservation: PropTypes.object.isRequired
};
export default SMUReservationMessageCloseView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationMessageCloseView.jsx